export default function shortNumberFormat(value: number): string {
  if (value < 0) return value.toFixed(2).toString();
  if (value < 1000) return value.toFixed(1).toString();
  if (value < 1000000) return (value / 1000).toFixed(1).toString() + 'K';
  if (value < 1000000000) return (value / 1000000).toFixed(1).toString() + 'M';
  return (value / 1000000000).toFixed(1).toString() + 'B';
}
